import * as Schema from "effect/Schema";

import { FormField } from "./form-field.js";

/**
 * FormWidget — contact-form-style widget. Field set is small (text /
 * email / textarea / checkbox); submissions email via homelab SMTP
 * (no per-tenant transactional-email account). The site owner's
 * delivery address is in the FormWidget (not on the field) so a single
 * site can have multiple forms going to different recipients (e.g. a
 * "contact" form vs. a "careers" form).
 */
export const FormWidgetContent = Schema.Struct({
  contentType: Schema.Literal("form"),
  fields: Schema.Array(FormField).pipe(Schema.minItems(1)),
  submitButtonLabel: Schema.String,
  deliveryEmail: Schema.optional(Schema.String),
});
export type FormWidgetContent = Schema.Schema.Type<typeof FormWidgetContent>;
